module.exports = __webpack_public_path__ + "media/images/close_red-cf3e626983224271462b051dfdaf3b23.svg";